import React from "react";
import { Image } from "react-konva";
import useImage from "use-image";

const Img = ({
  shapeProps,
  isSelected,
  onSelect,
  onChange,
  imageUrl,
  image,
  tool,
}) => {
  const imageRef = React.useRef();
  const [img] = useImage(imageUrl);

  const onMouseEnter = (event) => {
    if (isSelected) {
      event.target.getStage().container().style.cursor = "move";
    }
    if (!isSelected) {
      event.target.getStage().container().style.cursor = "pointer";
    }
  };

  const onMouseLeave = (event) => {
    event.target.getStage().container().style.cursor = "default";
  };

  return (
    <React.Fragment>
      <Image
        image={img}
        x={image.x}
        y={image.y}
        tool="uploadedImage"
        name="selectable"
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        onClick={onSelect}
        onTap={onSelect}
        ref={imageRef}
        {...shapeProps}
        draggable={tool === "none" ? true : false}
        onDragEnd={(e) => {
          onChange({
            ...shapeProps,
            x: e.currentTarget.x(),
            y: e.currentTarget.y(),
          });
        }}
        onTransformEnd={(e) => {
          const node = imageRef.current;
          const scaleX = node.scaleX();
          const scaleY = node.scaleY();

          // node.scaleX(1);
          // node.scaleY(1);
          onChange({
            ...shapeProps,
            x: node.x(),
            y: node.y(),
            scaleX,
            scaleY,
            rotation: node.attrs.rotation,
            // width: node.width() * scaleX,
            // height: node.height() * scaleY,
          });
        }}
      />
    </React.Fragment>
  );
};
export default Img;
